import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productNameColumnHeader: {
    id: 'h2+9yK',
    defaultMessage: 'Product',
    description: 'Header for the product name column in the product grid',
  },
  costColumnHeader: {
    id: 'gZb9qz',
    defaultMessage: 'Cost',
    description: 'Header for the cost column in the product grid',
  },
  totalCostColumnHeader: {
    id: '+M3bMe',
    defaultMessage: 'Total',
    description: 'Header for the total cost column in the product grid',
  },
  expectedDeliveryDateColumnHeader: {
    id: '6BcuLX',
    defaultMessage: 'Exp. Date',
    description: 'Header for the expected delivery date column in the product grid',
  },
  receivedColumnHeader: {
    id: '1b83tx',
    defaultMessage: 'Received',
    description: 'Header for the received column in the product grid',
  },
  unreceivedColumnHeader: {
    id: '252BhX',
    defaultMessage: 'Unreceived',
    description: 'Header for the unreceived column in the product grid',
  },
});
